import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Phonics Grand Prix',
    description: "Explore Phonics Racing Island, blend CVC words, fix and upgrade your race car and win the Phonics Grand Prix. A 3D racing adventure for Year 1 pupils.",
    url: getOrigin()
}
